import { render, staticRenderFns } from "./CopilotSuggestion.vue?vue&type=template&id=e0876cb6&scoped=true"
import script from "./CopilotSuggestion.vue?vue&type=script&lang=js"
export * from "./CopilotSuggestion.vue?vue&type=script&lang=js"
import style0 from "./CopilotSuggestion.vue?vue&type=style&index=0&id=e0876cb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0876cb6",
  null
  
)

export default component.exports